import { render, staticRenderFns } from "./ClientUserDetailPage.vue?vue&type=template&id=cb8a777e&"
import script from "./ClientUserDetailPage.vue?vue&type=script&lang=js&"
export * from "./ClientUserDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports